<template>
  <div>

    <div style="padding-left: 18px;padding-right: 18px;height: 100%;">
      <div>
        <el-row :gutter="0" class="panel-group" style="height:  570px;    display: -webkit-box;">
          <el-col :span="12" class="card-panel-col">
            <div class="card-panel" style="float: left;padding-top: 20px;">
              <div class="card-panel-icon-wrapper icon-message" style="width: 180px;">
                <div>
                  <svg-icon icon-class="shebeiguozai" class-name="card-panel-icon" />
                </div>
                <div style=" line-height: 58px; color: rgba(0, 0, 0);  font-size: 15px;  ">
                  设备过载
                </div>
              </div>


            </div>
            <div style="float: left;padding-top: 20px;">
              <el-table border stripe :data="sbgz" style="font-size: 14px;width: 100%;">

                <el-table-column prop="address" label="仪表位置" width="105" align="center"
                  style="background-color: #ebeef5;" className="aabbshenmz">
                </el-table-column>
                <el-table-column prop="localNumber" label="现场编号" width="85" align="center"
                  style="background-color: #ebeef5;" className="aabbshenmz">
                </el-table-column>
                <el-table-column prop="count" label="报警次数" width="85" align="center" style="background-color: #ebeef5;"
                  className="aabbshenmz">
                </el-table-column>
                <el-table-column prop="desc" label="设备描述" width="265" align="center" style="background-color: #ebeef5;"
                  className="aabbshenmz">
                </el-table-column>

              </el-table>
            </div>

          </el-col>
          <el-col :span="12" class="card-panel-col" style="margin-left: 10px;">
            <div class="card-panel" style="float: left;padding-top: 20px;">
              <div class="card-panel-icon-wrapper icon-message" style="width: 180px;">
                <div>
                  <svg-icon icon-class="shebeichongzai" class-name="card-panel-icon" />
                </div>
                <div style=" line-height: 58px; color: rgba(0, 0, 0);  font-size: 15px;  ">
                  设备重载
                </div>
              </div>


            </div>
            <div style="float: left;padding-top: 20px;">
              <el-table border stripe :data="sbcz" style="font-size: 14px;width: 100%;">

                <el-table-column prop="address" label="仪表位置" width="105" align="center"
                  style="background-color: #ebeef5;" className="aabbshenmz">
                </el-table-column>
                <el-table-column prop="localNumber" label="现场编号" width="85" align="center"
                  style="background-color: #ebeef5;" className="aabbshenmz">
                </el-table-column>
                <el-table-column prop="count" label="报警次数" width="85" align="center" style="background-color: #ebeef5;"
                  className="aabbshenmz">
                </el-table-column>
                <el-table-column prop="desc" label="设备描述" width="265" align="center" style="background-color: #ebeef5;"
                  className="aabbshenmz">
                </el-table-column>

              </el-table>
            </div>

          </el-col>
        </el-row>

        <el-row :gutter="0" class="panel-group" style="height:  570px;    display: -webkit-box;">
          <el-col :span="12" class="card-panel-col">
            <div class="card-panel" style="float: left;padding-top: 20px;">
              <div class="card-panel-icon-wrapper icon-message" style="width: 180px;">
                <div>
                  <svg-icon icon-class="dixian" class-name="card-panel-icon" />
                </div>
                <div style=" line-height: 58px; color: rgba(0, 0, 0);  font-size: 15px;  ">
                  设备低限
                </div>
              </div>


            </div>
            <div style="float: left;padding-top: 20px;">
              <el-table border stripe :data="sbdx" style="font-size: 14px;width: 100%;">

                <el-table-column prop="address" label="仪表位置" width="105" align="center"
                  style="background-color: #ebeef5;" className="aabbshenmz">
                </el-table-column>
                <el-table-column prop="localNumber" label="现场编号" width="85" align="center"
                  style="background-color: #ebeef5;" className="aabbshenmz">
                </el-table-column>
                <el-table-column prop="count" label="报警次数" width="85" align="center" style="background-color: #ebeef5;"
                  className="aabbshenmz">
                </el-table-column>
                <el-table-column prop="desc" label="设备描述" width="265" align="center" style="background-color: #ebeef5;"
                  className="aabbshenmz">
                </el-table-column>

              </el-table>
            </div>

          </el-col>
          <el-col :span="12" class="card-panel-col" style="margin-left: 10px;">
            <div class="card-panel" style="float: left;padding-top: 20px;">
              <div class="card-panel-icon-wrapper icon-message" style="width: 180px;">
                <div>
                  <svg-icon icon-class="didixian" class-name="card-panel-icon" />
                </div>
                <div style=" line-height: 58px; color: rgba(0, 0, 0);  font-size: 15px;  ">
                  设备低低限
                </div>
              </div>


            </div>
            <div style="float: left;padding-top: 20px;">
              <el-table border stripe :data="sbddx" style="font-size: 14px;width: 100%;">

                <el-table-column prop="address" label="仪表位置" width="105" align="center"
                  style="background-color: #ebeef5;" className="aabbshenmz">
                </el-table-column>
                <el-table-column prop="localNumber" label="现场编号" width="85" align="center"
                  style="background-color: #ebeef5;" className="aabbshenmz">
                </el-table-column>
                <el-table-column prop="count" label="报警次数" width="85" align="center" style="background-color: #ebeef5;"
                  className="aabbshenmz">
                </el-table-column>
                <el-table-column prop="desc" label="设备描述" width="265" align="center" style="background-color: #ebeef5;"
                  className="aabbshenmz">
                </el-table-column>

              </el-table>
            </div>

          </el-col>
        </el-row>



      </div>
    </div>
  </div>
</template>

<script>
  // import layout1 from "../../layout/layout1";
  // import ECharts from "vue-echarts";
  export default {
    name: "bianyaqi",
    data () {
      return {
        projectId: 0,
        datas: {},
        sbgz: [],
        sbcz: [],
        sbdx: [],
        sbddx: []
      };
    },
    props: {
      date: {
        type: String
      },
      dateType: {
        type: String
      }
    },
    components: {
      // layout1, 
      // "v-chart": ECharts,
    },
    created () {
      this.projectId = this.$getCookie("projectId");

      this.searchPeak();
    },
    mounted () {

    },
    computed: {

    },
    watch: {

    },
    methods: {
      searchPeak () {
        this.todayEleLoading = true;
        let strs = this.date.split("-")
        let str = strs[0] + "-" + strs[1]
        this.$http
          .post("bma-distribution-service/monthReport/searchTelemetryOverLimit", {
            date: str,
            projectId: this.projectId,
            dateType: this.dateType
          })
          .then((res) => {


            this.sbgz = res.data.sbgz
            this.sbcz = res.data.sbcz
            this.sbdx = res.data.sbdx
            this.sbddx = res.data.sbddx

          });
      },

    },
  };
</script>

<style lang="scss" scoped>
  .panel-group {
    margin-top: 18px;




    .card-panel-col {
      background: #fff;

      /* margin-bottom: 32px; */
      ~.el-table .cell {
        padding-left: 0px;
      }
    }

    .card-panel-col>.cell {

      padding-left: 0px;

    }

    .card-panel {
      height: 208px;
      font-size: 12px;
      position: relative;
      overflow: hidden;
      border-color: rgba(0, 0, 0, .05);



      .icon-people {
        color: #40c9c6;
      }

      .icon-message {
        color: #36a3f7;
      }

      .icon-money {
        color: #f4516c;
      }

      .icon-shopping {
        color: #34bfa3
      }

      .card-panel-icon-wrapper {
        float: left;
        margin: 54px 0 0 14px;
        width: 100px;
        text-align: center;
        /* padding: 16px; */
        transition: all 0.38s ease-out;
        border-radius: 6px;
      }

      .card-panel-icon {
        /* float: left; */
        font-size: 48px;
      }

      .card-panel-description {
        float: left;
        font-weight: bold;
        margin-top: 56px;
        margin-left: 10px;
        text-align: left;
        width: 200px;

        .card-panel-text {
          line-height: 18px;
          color: rgba(0, 0, 0);
          font-size: 16px;
          margin-bottom: 12px;
        }

        .card-panel-text-info {
          line-height: 18px;
          color: rgba(0, 0, 0, 0.45);
          font-size: 14px;
          margin-bottom: 12px;
        }

        .card-panel-num {
          font-size: 20px;
        }
      }
    }
  }
</style>